/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icn_networks': {
    width: 16,
    height: 16,
    viewBox: '0 0 22.5 18',
    data: '<path pid="0" d="M21.375 0H1.125A1.063 1.063 0 000 1.125v15.75A1.063 1.063 0 001.125 18h20.25a1.063 1.063 0 001.125-1.125V1.125A1.063 1.063 0 0021.375 0zm-11.25 13.5h-6.75a1.125 1.125 0 010-2.25h6.75a1.125 1.125 0 010 2.25zm0-4.5h-6.75a1.125 1.125 0 010-2.25h6.75a1.125 1.125 0 010 2.25zM18 12.15v3.6l-1.125-1.125-1.125 1.125v-3.6A3.277 3.277 0 0113.5 9a3.375 3.375 0 116.75 0A3.277 3.277 0 0118 12.15zm1.125-7.65H3.375A1.127 1.127 0 012.25 3.375 1.063 1.063 0 013.375 2.25h15.75a1.125 1.125 0 110 2.25z" _fill="#fff"/>'
  }
})
